import { css, jsx } from '@emotion/core';
import { List } from 'antd';
import React from 'react';

import Link from '@/src/shared/components/Link';
import { colors } from '@/styles';

const style = {
  meta: css`
    .ant-list-item-meta-title {
      margin-bottom: 0;
      a {
        color: ${colors.primaryBlue};
      }
    }
  `,
};

function Sources({ bulletins }) {
  return (
    <List
      itemLayout="vertical"
      size="small"
      dataSource={bulletins}
      renderItem={source => (
        <List.Item key={source.Category}>
          <List.Item.Meta
            css={style.meta}
            title={<Link href={`/publications/${source.SitePageId}`}>{source.PageTitle}</Link>}
            description={<p>{source.Publications}</p>}
          />
          {source.ExecutiveSummary}
        </List.Item>
      )}
    />
  );
}

export default Sources;
